import { render, staticRenderFns } from "./CopyAssetsModal.vue?vue&type=template&id=3f4d7c13&scoped=true"
import script from "./CopyAssetsModal.vue?vue&type=script&lang=js"
export * from "./CopyAssetsModal.vue?vue&type=script&lang=js"
import style0 from "./CopyAssetsModal.vue?vue&type=style&index=0&id=3f4d7c13&prod&scoped=true&lang=scss"
import style1 from "./CopyAssetsModal.vue?vue&type=style&index=1&id=3f4d7c13&prod&lang=scss"
import style2 from "./CopyAssetsModal.vue?vue&type=style&index=2&id=3f4d7c13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d7c13",
  null
  
)

export default component.exports